import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
	OAuthData,
	OAuthDataState,
} from '../recoil-states/user-state/user-OAuth';
import close_btn from '../assets/close.svg';
import '../css/header.css';
import { post_Email_Login, _inputActionLog } from '../function/functions';
import { translatedText } from '../recoil-states/language-state';
import Loading from './Loading';
import { useHistory } from 'react-router-dom';
export default function OAuthModal({
	onGoogleSignIn = () => {},
	text = 'sign_with',
	setModalopen,
	Modalopen,
}) {
	const [userData, setUserData] = useRecoilState(OAuthData);
	const [userState, setUserState] = useRecoilState(OAuthDataState);
	const textData = useRecoilValue(translatedText);
	const [loading, setLoading] = useState(false);
	const [email, setEmail] = useState('');
	const [error, setError] = useState(null);
	const [magicUser, setMagicUser] = useState({});
	const history = useHistory();
	const GoogleOauthURL = process.env.REACT_APP_GOOGLE_OAUTH_URL;
	const Google_OAuthname = 'Google_OAuth';
	let OAuthOptions =
		'width = 500, height = 500 , top=0, right = 0, location = no ';
	const oAuthMap = {
		Google() {
			window.open(GoogleOauthURL, Google_OAuthname, OAuthOptions);
		},
	};
	const oAuthHandler = Oauth => {
		oAuthMap[Oauth]();
	};
	const handleChange = event => {
		setEmail(event.target.value);
	};

	useEffect(() => {
		async function getUserData(email, provider) {
			// setLoading(true)
			try {
				const _postEmailLogin = await post_Email_Login(email, provider);
				_inputActionLog(
					null,
					'GoogleOAuth 인증 성공',
					JSON.stringify(_postEmailLogin)
				);
				setUserData({ ..._postEmailLogin });
				setUserState(true);
				setModalopen(false);
			} catch (error) {
				_inputActionLog(
					null,
					'GoogleOAuth 인증 실패',
					JSON.stringify(error)
				);
				// setLoading(false);
				throw new Error(error);
			}
		}
		return () => {
			const email = localStorage.getItem('email');
			const provider = localStorage.getItem('provider');
			if (
				localStorage.getItem('email') &&
				localStorage.getItem('provider')
			) {
				getUserData(email, provider);
			}
		};
	}, []);

	useEffect(() => {
		window.addEventListener('storage', function () {
			if (
				this.localStorage.getItem('email') &&
				this.localStorage.getItem('provider')
			) {
				setModalopen(false);
			}
		});
	}, []);

	return (
		<div className='google_modal'>
			{loading ? <Loading /> : null}
			<div className='google_modal_container'>
				<img
					src={close_btn}
					id='close_btn'
					onClick={() => setModalopen(false)}
				/>
				<div className='oauth_img_box'>
					<p className='oauth_modal_text'>Login</p>
				</div>
				{/* 자체 로그인 작업중 */}
				{/* <div className="login_box">
        <Form onSubmit={handleSubmit} className="login_form p-2 my-5 mx-auto">
        <FormGroup className="login_formgroup mt-3">
          <FormLabel fontSize="xl" className="login_form_label">Enter Email Address</FormLabel>
          <FormControl
            type="email"
            name="email"
            id="email"
            value={email}
            onChange={handleChange}
            placeholder="Email Address"
          />
        {error ? <p className="error_text">{error}</p> : null}
        </FormGroup>
        <Button
          type="submit"
          size="md"
          className="d-block w-100"
          variant="primary"
        >
          {loading ? 'Loading...' : (MagicEmail?.length > 0 ? 'Log out' : 'Send' ?? 'Send')}
        </Button>
      </Form>
        </div> */}
				{/* 자체 로그인 작업중 */}
				<div className='oauth_btn_box'>
					<button
						id='oAuthBtn'
						onClick={() => oAuthHandler('Google')}
					>
						<img src={require('../assets/logo_google.png')} />
						<h1>{textData.modal['google_login']}</h1>
					</button>
				</div>
			</div>
		</div>
	);
}
